import { CommentResponse } from "@mutiny-group/sbo-openapi-client";

import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

export type CreateCommentV2Params = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioId: string;
  comment: string;
};

export const createCommentV2 = ({
  scenarioBuilderClient,
  scenarioId,
  comment,
}: CreateCommentV2Params): Promise<CommentResponse> => {
  return scenarioBuilderClient.scenarios.createComment({
    scenarioUuid: scenarioId,
    createCommentRequest: {
      comment,
    },
  });
};
